import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProcessComponent} from './process.component';
import {SharedModule} from "../shared/shared.module";
import {MaterialModule} from "../shared/material.module";
import {StatusTrackerModule} from "../status-tracker/status-tracker.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {SignupModule} from "../signup/signup.module";
import { HttpClientModule } from '@angular/common/http'
import {MatDialogModule} from "@angular/material/dialog";

@NgModule({
  declarations: [
    ProcessComponent

  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StatusTrackerModule,
    FlexLayoutModule,
    SignupModule,
    HttpClientModule,
    MatDialogModule
  ],
  exports: [
    ProcessComponent
  ],
  providers: []
})
export class ProcessModule {
}
